import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin } from "lucide-react";
import { OPEN_COOKIE_PREFERENCES_EVENT } from "@/components/CookieConsentBanner";

export const LandingPageFooter = () => {
  const currentYear = new Date().getFullYear();

  const columns = [
    {
      title: "Produto",
      links: [
        { label: "Buscar Vagas", to: "/candidato/vagas" },
        { label: "GPS Premium ✨", to: "/vendas", highlight: true },
        { label: "Para Candidatos", to: "/cadastro/candidato" },
        { label: "Para Empresas", to: "/para-empresas" },
        { label: "Planos", to: "/planos" },
        { label: "Blog", to: "/blog" },
      ],
    },
    {
      title: "Empresa",
      links: [
        { label: "Sobre nós", to: "/sobre-nos" },
        { label: "Trabalhe conosco", to: "/trabalhe-conosco" },
        { label: "Contato", to: "/contato" },
      ],
    },
    {
      title: "Suporte",
      links: [
        { label: "Central de Ajuda", to: "/suporte" },
        { label: "FAQ", to: "/faq" },
        { label: "Termos de Uso", to: "/termos" },
        { label: "Privacidade", to: "/privacidade" },
      ],
    },
  ];

  const socials = [
    { icon: <Linkedin className="w-5 h-5" />, href: "https://www.linkedin.com/", label: "LinkedIn" },
    { icon: <Instagram className="w-5 h-5" />, href: "https://www.instagram.com/gpsemprega/", label: "Instagram" },
    { icon: <Facebook className="w-5 h-5" />, href: "https://www.facebook.com/", label: "Facebook" },
  ];

  return (
    <footer className="bg-[#0B0F1A] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Top section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 py-16 border-b border-white/5">
          
          {/* Brand column - 2 col span */}
          <div className="lg:col-span-2 space-y-5">
            <Link to="/" className="flex items-center gap-2.5 group w-fit">
              <div className="w-9 h-9 bg-gps-medium-blue rounded-xl flex items-center justify-center shadow-md">
                <div className="w-4 h-4 bg-gps-yellow rotate-45 rounded-sm"></div>
              </div>
              <span className="text-xl font-bold font-display tracking-tight">
                GPS <span className="text-gps-medium-blue">Emprega</span>
              </span>
            </Link>
            
            <p className="text-gray-400 leading-relaxed max-w-xs text-sm">
              Conectando talentos ao destino certo. Sua plataforma completa para encontrar o emprego ideal ou o candidato perfeito.
            </p>
            
            {/* Social Links */}
            <div className="flex items-center gap-3 pt-2">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 hover:border-white/20 transition-all duration-200"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Nav columns */}
          {columns.map((col) => (
            <div key={col.title} className="space-y-5">
              {/* text-gray-400, not -500: -500 on this dark footer bg is
                  ~3.96:1, under WCAG AA's 4.5:1 minimum. -400 passes at ~7.5:1. */}
              <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-gray-400">
                {col.title}
              </h3>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className={
                        ("highlight" in link && link.highlight)
                          ? "text-gps-yellow font-semibold hover:text-yellow-300 text-sm transition-colors"
                          : "text-gray-400 hover:text-white text-sm transition-colors"
                      }
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between py-6 gap-4 text-sm text-gray-600">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 sm:justify-start">
            <p>© {currentYear} GPS Emprega. Todos os direitos reservados.</p>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event(OPEN_COOKIE_PREFERENCES_EVENT))}
              className="text-gray-600 underline-offset-2 hover:text-white hover:underline transition-colors"
            >
              Preferências de Cookies
            </button>
          </div>
          <div className="flex items-center gap-1">
            <span>Feito com</span>
            <span className="text-red-500 mx-1">♥</span>
            <span>para impulsionar carreiras no Brasil</span>
          </div>
        </div>
      </div>
    </footer>
  );
};